import { localeISO } from "./localeIso";

export const formatPrice = (price) => {
  return price?.toLocaleString(localeISO, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
